import { Button, Empty, Typography } from 'antd'
import { useTranslations } from 'next-intl'

interface Props {
  hasData: boolean
  text?: string
  showAction?: boolean
  actionText?: string
  children: React.ReactNode
  onButtonClick?: () => void
}

const NoData = ({
  hasData,
  text,
  showAction = false,
  actionText = 'component.noData.action',
  children,
  onButtonClick = () => {},
}: Props) => {
  const t = useTranslations()
  const defaultText = t('component.noData.text')

  return (
    <>
      {!hasData ? (
        <div className='flex flex-col justify-center p-10'>
          <Empty
            image={Empty.PRESENTED_IMAGE_SIMPLE}
            description={
              <Typography.Text>{text || defaultText}</Typography.Text>
            }
          />
          {showAction && (
            <div className='text-center'>
              <Button type='primary' className='mt-5' onClick={onButtonClick}>
                {t(actionText)}
              </Button>
            </div>
          )}
        </div>
      ) : (
        <>{children}</>
      )}
    </>
  )
}

export default NoData
